import { ProPilotMessageStatus } from "PFApp/stores/propilot_store";
import { LoadingDots } from "PFComponents/loading_dots/loading_dots";

import css from "./propilot_typing_indicator.module.scss";

type ProPilotTypingIndicatorProps = {
  status: ProPilotMessageStatus;
};

export const ProPilotTypingIndicator = ({ status }: ProPilotTypingIndicatorProps) => {
  if (status !== "streaming") {
    return null;
  }

  return (
    <div className={css.typingIndicator} data-qa-id="ProPilotTypingIndicator">
      <LoadingDots circlesEnabled circleSize="xs" qaId="ProPilotTypingIndicator.dots" />
    </div>
  );
};
